<template>
  <div>
    <div style="margin: 10px 10px 14px">
      <el-checkbox-group
        v-model="checkList"
        @change="handleCheckboxGroupChange"
        :min="1"
      >
        <el-checkbox
          v-for="item in userExceptionTypeList"
          :key="item.value"
          :label="item.value"
          >{{ item.label }}</el-checkbox
        >
      </el-checkbox-group>
    </div>

    <el-tabs type="border-card">
      <el-tab-pane label="未处理">
        <device-exception-info-no
          ref="noException"
          :checkList="checkList"
          @fetchData="handleExceptionSuccess"
        />
      </el-tab-pane>
      <el-tab-pane label="已处理">
        <device-exception-info-yes ref="yesException" :checkList="checkList" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import DeviceExceptionInfoNo from "./DeviceExceptionInfoNo";
import DeviceExceptionInfoYes from "./DeviceExceptionInfoYes";

export default {
  name: "DeviceExceptionInfo",
  components: { DeviceExceptionInfoNo, DeviceExceptionInfoYes },
  data() {
    return {
      checkList: [],
      userExceptionTypeList: [
        { label: "0功率异常", value: 0 },
        { label: "离线未上线", value: 1 },
        { label: "插座,连续五次以上充电时间不足10分钟", value: 2 },
        { label: "连续30天无人使用", value: 3 },
      ],
    };
  },
  created() {
    const cache = localStorage.getItem("userExceptionTypeList");
    if (cache) {
      this.checkList = JSON.parse(cache);
    } else {
      this.checkList = this.userExceptionTypeList.map((u) => u.value);
    }
  },
  methods: {
    handleExceptionSuccess() {
      this.$refs.yesException.fetchData();
    },
    handleCheckboxGroupChange() {
      localStorage.setItem(
        "userExceptionTypeList",
        JSON.stringify(this.checkList)
      );

      this.$refs.yesException && this.$refs.yesException.fetchData();
      this.$refs.noException && this.$refs.noException.fetchData();
    },
  },
};
</script>
